module.exports = __webpack_public_path__ + "img/hero_video.6716f581.png";